"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateBillOfMaterial = void 0;
const class_validator_1 = require("class-validator");
const common_1 = require("../../common");
class UpdateBillOfMaterial extends common_1.UpdateAction {
}
__decorate([
    class_validator_1.IsInt(),
    class_validator_1.IsOptional(),
    class_validator_1.Min(1),
    class_validator_1.Max(9999)
], UpdateBillOfMaterial.prototype, "quantity", void 0);
__decorate([
    class_validator_1.IsInt(),
    class_validator_1.IsOptional(),
    class_validator_1.Min(1),
    class_validator_1.Max(9999)
], UpdateBillOfMaterial.prototype, "lineNumber", void 0);
__decorate([
    class_validator_1.IsString(),
    class_validator_1.IsOptional(),
    class_validator_1.IsNotEmpty()
], UpdateBillOfMaterial.prototype, "componentId", void 0);
exports.UpdateBillOfMaterial = UpdateBillOfMaterial;
//# sourceMappingURL=update-bill-of-material.action.js.map